<template>
    <div>
        <login v-if="!$store.getters.userIsAuthenticated && $route.name !== 'reset-password'"></login>
        <reset-password v-else-if="!$store.getters.userIsAuthenticated && $route.name == 'reset-password'"></reset-password>
        <fundation-layout v-else>
            <div class="viveco-app">
                <router-view></router-view>
            </div>
        </fundation-layout>
    </div>
</template>

<script>
/*global VERSION:true*/
import Loading from 'fundation-app-vuejs/src/components/loading/index.vue';
import Login from './components/page/login.vue';
import resetPassword from './components/page/resetPassword.vue';
import {FundationLayout} from 'fundation-app-vuejs';


export default {
    name: 'App',
    components: {
        Loading,
        Login,
        resetPassword,
        FundationLayout
    },
    computed: {
        version (){
            try{
                return VERSION;
            }catch(e){
                console.error(e);
                return '';
            }
        },
    },
};
</script>

<style lang="scss">
@font-face {
    font-family: "work sans";
    src: url("../static/fonts/WorkSans-Regular.ttf") format('truetype');
}
@font-face {
    font-family: "work sans extra light";
    src: url("../static/fonts/WorkSans-ExtraLight.ttf") format('truetype');
}
@font-face {
    font-family: "work sans bold";
    src: url("../static/fonts/WorkSans-Bold.ttf") format('truetype');
}
@font-face {
    font-family: "frutiger";
    src: url("../static/fonts/FrutigerLTStd-Light.ttf") format('truetype');
}
html, body{
    margin: 0px;
    padding: 0px;
}

.version {
    position: absolute;
    bottom: 0;
    left: 10px;
}

.viveco-app {
    background-color: #FFF;
    width: 100%;
}

</style>



// WEBPACK FOOTER //
// src/App.vue